import React, { Component } from 'react';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { withTranslation } from "react-i18next";
import renderSelectField from '../../../shared/components/form/Select';
import { translate } from '../../../translations/i18n';
import withErrorNotification from '../../../hof/withErrorNotification';
import { Posts } from '../../../services/Posts';
import Notifications from '../../../hof/notifications';
import { initCurrentBlog } from '../../../redux/actions/blogsActions';
import { fetchDrafts } from '../../../redux/actions/draftsActions';
import { fetchPosts } from '../../../redux/actions/postsActions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import LoadingIcon from 'mdi-react/LoadingIcon';

const selector = formValueSelector('blog_import_posts')

class ImportPosts extends Component {

    constructor() {
        super();
        this.state = {
            inProgress: false
        }
    }

    handleSubmit = async () => {

        if (!this.state.inProgress) {

            if (this.props.category) {

                this.setState({inProgress: true});
                console.log(this.props.category);
                await withErrorNotification(async () => {

                    const result = await Posts.importAll(this.props.blog._id, this.props.category.value)
                    Notifications.showNotification(translate('create.wizard.import.notifications.success.title'),
                        `${translate('create.wizard.import.notifications.success.body')}: ${result.total}`,
                        Notifications.Colors.SUCCESS)
                    this.setState({inProgress: false});

                    this.props.initCurrentBlog(this.props.blog._id);
                    this.props.fetchDrafts(this.props.blog._id);
                    this.props.fetchPosts(this.props.blog._id);

                    setTimeout(() => {
                        this.props.history.push(`/`);
                    }, 400)
                }, () => {
                    this.setState({inProgress: false});
                });
            } else {
                Notifications.showNotification(translate('create.wizard.import.notifications.select_category.title'),
                    translate('create.wizard.import.notifications.select_category.body'), Notifications.Colors.ERROR)
            }
        }
    }

    render() {
        const {handleSubmit, t} = this.props;

        return (
            <Col xs={12} md={12} lg={12} xl={12}>
                <Card>
                    <CardBody>
                        <div className="card__title">
                            <h5 className="bold-text">{t('settings.import_posts.title')}</h5>
                        </div>
                        <form className="form form--horizontal" onSubmit={handleSubmit}>
                            <div className="form__form-group">
                                <span
                                    className="form__form-group-label">{t(
                                    'settings.import_posts.choose_category.label')}:</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="category"
                                        component={renderSelectField}
                                        type="text"
                                        options={this.props.blog.categories.map(category => ({
                                            value: category._id,
                                            label: category.name
                                        }))}
                                        placeholder={translate('create.wizard.import.choose_category')}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label"></span>
                                <div className="form__form-group-field">
                                    <Button size="sm" outline color="primary"
                                            onClick={this.handleSubmit}>
                                            {this.state.inProgress && <LoadingIcon/>}
                                            {t('create.wizard.import.button_import')}
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </CardBody>
                </Card>
            </Col>
        );
    }


}

const mapStateToProps = (state) => {
    const category = selector(state, 'category')
    return {
        category,
        blog: state.blogs.blog
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        initCurrentBlog: (blogId) => dispatch(initCurrentBlog(blogId)),
        fetchDrafts: (blogId) => dispatch(fetchDrafts(blogId)),
        fetchPosts: (blogId) => dispatch(fetchPosts(blogId))
    }
}

ImportPosts = withRouter(connect(mapStateToProps, mapDispatchToProps)(ImportPosts));

export default reduxForm({form: 'blog_import_posts'})(withTranslation('dashboard')(ImportPosts));
